<script lang="ts">
	import type { ChartFilterType } from 'customTypes/filterTypes';
	import IntersectionObserver from 'components/IntersectionObserver/IntersectionObserver.svelte';
	import ChartStub from './ChartStub.svelte';

	export let id: string;
	export let dark: boolean;
	export let name: string;
	export let coingeckoId: string;
	export let coinrankingId: string;
	export let coinmarketcapId: number;
	export let chartFilterType: ChartFilterType = 'price';

	const title = name ? `${name} to USD chart` : '';
</script>

<div class="container">
	<IntersectionObserver let:intersecting once={true}>
		{#if intersecting}
			{#await import('components/Chart/Chart.svelte')}
				<ChartStub {dark} {title} />
			{:then c}
				<svelte:component
					this={c.default}
					{dark}
					{id}
					{chartFilterType}
					{name}
					{coingeckoId}
					{coinrankingId}
					{coinmarketcapId}
				/>
			{/await}
		{:else}
			<ChartStub {dark} {title} />
		{/if}
	</IntersectionObserver>
</div>

<style lang="scss">
	@import 'src/styles/shared';
	.container {
		margin-bottom: 40px;
		@include for-size(mobile-only) {
			padding: 0;
			width: 100%;
			max-width: none;
			overflow-y: hidden;
			overflow-x: scroll;
			&::-webkit-scrollbar {
				display: none;
			}
			-ms-overflow-style: none;
			scrollbar-width: none;
		}
		@include for-size(tablet) {
			max-width: 1440px;
		}
	}
</style>
